/*
 * Article table-of-contents builder — JakeSales (Dawn v7 -> v15.5.0 migration).
 * Populates the "Covered in this article:" sidebar (#dynamic-article-nav) with a
 * link to each <h2> in the article body (.article-content), assigning an id to
 * any heading that lacks one so the in-page anchors work.
 * Ported verbatim from the old theme's inline script (it was already jQuery-free).
 */
(function () {
  function buildArticleNav() {
    const content = document.querySelector('.article-content');
    const navContainer = document.getElementById('dynamic-article-nav');

    if (!content || !navContainer) return;

    const headings = content.querySelectorAll('h2');

    headings.forEach((heading, index) => {
      if (!heading.id) {
        heading.id = 'section-' + index;
      }

      const li = document.createElement('li');
      const a = document.createElement('a');

      a.textContent = heading.textContent;
      a.href = '#' + heading.id;

      li.appendChild(a);
      navContainer.appendChild(li);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildArticleNav);
  } else {
    buildArticleNav();
  }
})();
